var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticStyle:{"margin-top":"0px"},attrs:{"id":"app"}},[_c('AppHeader'),_c('UserDetails')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }